import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoDropdown16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M13 1.70001C14.1046 1.70001 15 2.59544 15 3.70001V12.2996C15 13.4042 14.1046 14.2996 13 14.2996H3L2.7959 14.2899C1.78719 14.1876 1 13.3353 1 12.2996V3.70001C1 2.59544 1.89543 1.70001 3 1.70001H13ZM3 2.95001C2.58579 2.95001 2.25 3.2858 2.25 3.70001V12.2996C2.25 12.7138 2.58579 13.0496 3 13.0496H13C13.4142 13.0496 13.75 12.7138 13.75 12.2996V3.70001C13.75 3.2858 13.4142 2.95001 13 2.95001H3ZM10.7578 6.15802C11.0018 5.91424 11.3976 5.9143 11.6416 6.15802C11.8856 6.40211 11.8856 6.79874 11.6416 7.04279L9.00781 9.67657C8.45135 10.2327 7.54857 10.2328 6.99219 9.67657L4.35742 7.04279C4.11345 6.79881 4.11365 6.40212 4.35742 6.15802C4.6015 5.91394 4.99811 5.91394 5.24219 6.15802L7.87598 8.79279C7.94421 8.8609 8.05571 8.86077 8.12402 8.79279L10.7578 6.15802Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoDropdown16;